import { Link as MuiLink } from '@mui/material';
import { MouseEvent, ReactNode } from 'react';
type Props = {
    children: ReactNode;
    onClick?: () => void;
    color?: 'primary' | 'secondary';
    underline?: 'always' | 'hover' | 'none';
};

const Link = ({ onClick, children, color, underline }: Props) => {
    const click = (e: MouseEvent) => {
        if (onClick) {
            onClick();
        }
        e.preventDefault();
    };

    return (
        <MuiLink onClick={click} color={color ?? 'primary'} variant="body2" underline={underline ?? 'always'} href="#">
            {children}
        </MuiLink>
    );
};

export default Link;
